import { useState, type SyntheticEvent } from 'react'
import { useElementAuth } from '../../store'

export function ElementLoginPage() {
  const {
    performElementLogin,
    isAuthenticationLoading,
    authenticationError,
    clearAuthenticationError
  } = useElementAuth()

  const [loginEmailAddress, setLoginEmailAddress] = useState<string>('')
  const [loginPassword, setLoginPassword] = useState<string>('')

  async function handleLoginFormSubmit(
    formSubmitEvent: SyntheticEvent<HTMLFormElement>
  ): Promise<void> {
    formSubmitEvent.preventDefault()
    clearAuthenticationError()
    try {
      await performElementLogin(loginEmailAddress, loginPassword)
    } catch {
      // error is handled in store
    }
  }

  function handleLoginKeyDown(
    keyboardEvent: React.KeyboardEvent<HTMLInputElement>
  ): void {
    if (keyboardEvent.key === 'Enter') {
      clearAuthenticationError()
      performElementLogin(loginEmailAddress, loginPassword)
    }
  }

  return (
    <div className="element-login-page">
      <div className="element-login-card">
        <div className="element-login-brand">
          <h1 className="element-login-brand-name">Element</h1>
          <p className="element-login-brand-tagline">Mail Platform</p>
        </div>

        <form
          className="element-login-form"
          onSubmit={handleLoginFormSubmit}
          noValidate
        >
          <div className="element-login-field">
            <label
              className="element-login-field-label"
              htmlFor="element-login-email"
            >
              Email address
            </label>
            <input
              id="element-login-email"
              type="email"
              className="element-login-field-input"
              placeholder="you@yourdomain.com"
              value={loginEmailAddress}
              onChange={changeEvent => setLoginEmailAddress(changeEvent.target.value)}
              onKeyDown={handleLoginKeyDown}
              autoComplete="email"
              autoFocus
              disabled={isAuthenticationLoading}
            />
          </div>

          <div className="element-login-field">
            <label
              className="element-login-field-label"
              htmlFor="element-login-password"
            >
              Password
            </label>
            <input
              id="element-login-password"
              type="password"
              className="element-login-field-input"
              placeholder="••••••••"
              value={loginPassword}
              onChange={changeEvent => setLoginPassword(changeEvent.target.value)}
              onKeyDown={handleLoginKeyDown}
              autoComplete="current-password"
              disabled={isAuthenticationLoading}
            />
          </div>

          {authenticationError && (
            <div className="element-login-error-message" role="alert">
              {authenticationError}
            </div>
          )}

          <button
            type="submit"
            className="element-login-submit-button"
            disabled={isAuthenticationLoading || !loginEmailAddress || !loginPassword}
          >
            {isAuthenticationLoading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  )
}
